import { RecordingState } from "./types";
import { chooseService }  from "../../utils";

export const initialState: RecordingState = {
  startPoint: null,
  endPoint: null,
  mode: chooseService(() => 'avi', () => 'createBookmark'),
  avilist: [],
  shareAviID: null
};